import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=6fda786e&scoped=true&"
import script from "./ProfilePage.vue?vue&type=script&lang=js&"
export * from "./ProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProfilePage.vue?vue&type=style&index=1&id=6fda786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda786e",
  null
  
)

export default component.exports